// Class strings the phone-sheet fields share, in a module of their own so a field
// can take one without importing the sheet picker it lives beside (BL-2753).

/** A field's label on a phone sheet: the sheet's stacked label, 16px / 500 gray-800 (BL-2402, BL-2293). */
export const SHEET_FIELD_LABEL_CLASS = 'mb-1.5 block text-body-lg font-medium text-gray-800';

/**
 * The 16px band between a phone sheet's sections (ADR 063 — Type Scale Amendment 6,
 * pattern 8; BL-2621, BL-2543): a #f5f5f5 band (neutral-100) under a 1px #e5e5e5 line
 * (neutral-200), the line an outer shadow so it takes no layout. Both edges are
 * decorative (contrast-floor.md rule 4). Shared by the drawer's sections and the
 * Add bidder sheet (BL-2757).
 */
export const SHEET_SECTION_BAND_CLASS = 'border-t-band border-neutral-100 shadow-[0_-1px_0_0_theme(colors.neutral.200)]';
